import React from "react";
import ReactDOM from "react-dom";
import BenefitPlanOnboardingModal from "../../../app/components/modals/BenefitPlanOnboardingModal";

export default function renderBenefitPlanOnboardingModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<BenefitPlanOnboardingModal {...rest} />, domTarget);
  }
}
